import { MenuItem, Stack, TextField } from "@mui/material";
import type { ReactElement } from "react";
import type { Gender } from "../../domain/types";
import { genders, parseGender } from "../../domain/types";

export type NameFieldsValue = {
  readonly name: string;
  readonly gender: Gender;
  readonly notes: string;
};

export const NameFields = ({
  value,
  onChange,
  disabled = false,
}: {
  readonly value: NameFieldsValue;
  readonly onChange: (value: NameFieldsValue) => void;
  readonly disabled?: boolean;
}): ReactElement => (
  <Stack spacing={2}>
    <TextField
      label="Name"
      value={value.name}
      disabled={disabled}
      required
      autoFocus
      onChange={(event) => onChange({ ...value, name: event.target.value })}
    />
    <TextField
      select
      label="Gender"
      value={value.gender}
      disabled={disabled}
      onChange={(event) =>
        onChange({ ...value, gender: parseGender(event.target.value) })
      }
    >
      {genders.map((gender) => (
        <MenuItem key={gender} value={gender}>
          {gender[0]?.toUpperCase()}
          {gender.slice(1)}
        </MenuItem>
      ))}
    </TextField>
    <TextField
      label="Notes"
      value={value.notes}
      disabled={disabled}
      multiline
      minRows={3}
      placeholder="Origin, meaning, family connection, or anything else"
      onChange={(event) => onChange({ ...value, notes: event.target.value })}
    />
  </Stack>
);
